import slice from './slice';

export const {
    addStructure, changeProteinFamily,
    changeTarget, removeStructure,
    addGroup, removeGroup,
    setCompoundTableState, setScoringTableState,
    setJobsCompoundsTableState,
    setSidePanelWidth,
    removeAllStructures, reset,
    setCoralMapState, setTableState,
    setProteinTarget, updateStructureAlignment,
    setAllTargetInfo, setActiveChart,
    setTargetsTableState,
    setScreeningTableState,
    setJobsGridTableState,
    updateScreeningPropertySettings,
} = slice.actions;

export default slice.reducer;
